/*
 * FANNUR Personalizer v0.5 — Shopify-native PNG file property integration.
 * Dependencies loaded in this order: templates, text module, photo module, core.
 * Theme-only: no cloud backend, no AJAX add.js file upload.
 */
(() => {
  'use strict';
  if (window.__FANNUR_V05_LOADED__) return;
  window.__FANNUR_V05_LOADED__ = true;
  window.__WA_PERSONALIZER_VERSION__ = '0.5';
  const TEMPLATES = window.FANNUR_TEMPLATES_V05 || {};
  const MODULES = window.FANNUR_MODULES_V05 || {};
  const FONT_SERVICE = window.FANNUR_FONTS_V05;
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
  const hex=(s,backup)=>/^#[0-9a-fA-F]{6}$/.test(String(s||''))?s:backup;
  const parseJSON=(str, fallback)=>{try{return JSON.parse(str)||fallback;}catch{return fallback;}};
  const sourceRoot=window.Shopify?.routes?.root||'/';
  const cartEditorParams=new URLSearchParams(window.location.search);
  const cartEditorMode=cartEditorParams.has('fannur_edit')?'edit':cartEditorParams.has('fannur_copy')?'copy':null;
  const cartEditorId=cartEditorMode?cartEditorParams.get(cartEditorMode==='edit'?'fannur_edit':'fannur_copy'):null;
  let cartEditorResumeStarted=false;
  async function resumeCartDesign(entry,form){
    if(cartEditorResumeStarted||!cartEditorId)return;
    cartEditorResumeStarted=true;
    try{
      if(!/^FN-[\w-]{6,90}$/i.test(cartEditorId))throw Error('Dit ontwerpnummer is ongeldig.');
      const result=await fetch(sourceRoot+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!result.ok)throw Error('De winkelwagen kon niet worden opgehaald.');
      const cart=await result.json();
      const item=(cart.items||[]).find(i=>i.properties?.['Ontwerpnummer']===cartEditorId);
      if(!item)throw Error('Dit ontwerp staat niet meer in je winkelwagen. Je kunt wel een nieuw ontwerp maken.');
      if(String(item.product_id)!==String(entry.dataset.waProductId))throw Error('Dit ontwerp hoort bij een ander product.');
      if(!item.properties?.['Ontwerp PNG'])throw Error('Dit ontwerp is niet via de FANNUR-editor opgeslagen.');
      open(entry,form,{item,mode:cartEditorMode,id:cartEditorId});
    }catch(error){window.alert(customerErrorText(error.message||L('errorResume')));}
  }
  const errorText=e=>customerErrorText(e?.message||L('errorGeneric'));

  const L=key=>window.FANNUR_I18N?.t(key)||key;
  const customerErrorText=value=>{
    const v=String(value||'');
    const errors={
      'Dit ontwerpnummer is ongeldig.':'errorResume','De winkelwagen kon niet worden opgehaald.':'errorResume','Dit ontwerp staat niet meer in je winkelwagen. Je kunt wel een nieuw ontwerp maken.':'errorOutdated','Dit ontwerp hoort bij een ander product.':'errorResume','Dit ontwerp is niet via de FANNUR-editor opgeslagen.':'errorResume','Het ontwerp kon niet worden geladen.':'errorResume',
      'Dit ontwerptype is nog niet geactiveerd. Controleer de personalizer-instellingen van dit product.':'errorGeneric','De originele ontwerptemplate komt niet overeen met dit product.':'errorResume','De lettertype-module van FANNUR ontbreekt. Controleer je scriptvolgorde.':'errorGeneric',
      'Selecteer eerst een beschikbare productvariant.':'errorVariant','Selecteer eerst een geldige productvariant.':'errorVariant','Even wachten… lettertype wordt geladen.':'fontUpdating','Lettertype toegepast op je ontwerp.':'fontUpdated','Kies een JPG, PNG of WebP van maximaal 15 MB.':'invalidPhoto','Deze foto kan niet worden geopend.':'photoUnreadable','Foto heeft geen geldige afmetingen.':'photoUnreadable',
      'Foto toegevoegd. Je kunt de uitsnede en filters aanpassen.':'photoAdded','Deze foto heeft een beperkte resolutie. Voor grote afdrukken adviseren we een scherpere originele foto.':'smallPhoto',
      'Zoeken tijdelijk niet beschikbaar':'locationUnavailable','Geen locaties gevonden.':'noLocation','Zoeken is momenteel niet beschikbaar.':'locationUnavailable','Ongeldige foto-URL.':'photoReupload','Bronfoto niet beschikbaar.':'photoReupload','Bronfoto voldoet niet aan de bestandslimiet.':'invalidPhoto',
      'De originele foto is teruggeladen. Je kunt hem aanpassen.':'photoRestored','Upload de originele foto opnieuw om dit ontwerp aan te passen.':'photoReupload','De ontwerpachtergrond kan niet worden geladen.':'backgroundError','Het POD-artwork ontbreekt of is nog niet geladen. Controleer het metafield POD IMAGE.':'backgroundError',
      'Vul een naam en een rugnummer van één of twee cijfers in.':'jerseyRequired','Kan de PNG-renderer niet starten.':'errorPreview','Het ontwerpbestand is geen geldige PNG.':'errorPreview','De PNG-afmetingen komen niet overeen met de gekozen variant.':'errorVariant','De PNG is groter dan 18 MB. Verklein je originele foto of kies een eenvoudiger filter.':'errorLarge','Je browser ondersteunt de bestandsbijlage niet.':'errorBrowser','De PNG-bijlage kon niet aan het formulier worden toegevoegd.':'errorBrowser',
      'Een momentje… je artwork wordt opgeslagen':'saving','Momentje… je artwork wordt voorbereid.':'preparing','Je artwork wordt aan de bestelling toegevoegd.':'adding','Upload eerst je eigen foto.':'photoRequired','Lettertypen worden voorbereid…':'fontLoading','Je kunt nu je ontwerp aanpassen en bestellen.':'readyNow','Dit ontwerp is overgenomen. Pas het aan en voeg een tweede exemplaar toe.':'copied','Demo: bestellen is uitgeschakeld. Test de PNG-download.':'errorGeneric'
    };
    if(v.startsWith('Upload je foto opnieuw om dit ontwerp aan te passen.'))return L('photoReupload');
    return errors[v]?L(errors[v]):v;
  };
  function localizeDialog(node,template,fields,roles,settings){
    const el=s=>node.querySelector(s);
    const text=(s,k)=>{const n=el(s);if(n)n.textContent=L(k);};
    const prefix=(s,k)=>{const target=el(s)?.closest('label')||el(s);if(target?.firstChild?.nodeType===3)target.firstChild.textContent=L(k)+' ';};
    node.setAttribute('aria-label',L('dialog'));
    text('.fn-head strong span','brand');el('.fn-head strong em')?.remove();
    el('[data-close]')?.setAttribute('aria-label',L('close'));
    el('[data-preview]')?.setAttribute('aria-label',L('preview'));
    const dim=el('.fn-dimensions');if(dim)dim.textContent=dim.textContent.replace(template.name,L('tpl.'+template.id));
    text('.fn-eyebrow','intro');text('.fn-panel h2','tpl.'+template.id);
    for(const k of ['text','style','photo'])text('[data-tab="'+k+'"]',k);
    text('[data-pane="text"] h3','details');
    for(const f of fields){
      const inp=[...node.querySelectorAll('[data-field]')].find(n=>n.dataset.field===f.id);
      const span=inp?.closest('label')?.querySelector('span');
      if(span?.firstChild?.nodeType===3)span.firstChild.textContent=L('field.'+f.id)+' ';
    }
    for(const role of roles){
      const sel=[...node.querySelectorAll('[data-font-role]')].find(n=>n.dataset.fontRole===role.id);
      prefix(sel? '[data-font-role="'+role.id+'"]':'[data-font-role]','role.'+role.id);
    }
    node.querySelectorAll('[data-font-role] option').forEach(option=>{const key='font.'+option.value;if(L(key)!==key)option.textContent=L(key);});
    prefix('[data-location-search]','locationSearch');
    el('[data-location-search]')?.setAttribute('placeholder',L('locationPlaceholder'));
    if(settings.geoapifyKey)text('[data-geo-status]','locationHint');else el('.fn-location')?.remove();
    const headings=node.querySelectorAll('[data-pane="style"] h3');['background','textColor','fonts'].forEach((k,i)=>{if(headings[i])headings[i].textContent=L(k);});
    node.querySelectorAll('.fn-swatch').forEach(sw=>sw.setAttribute('aria-label',(sw.hasAttribute('data-bg')?L('background'):L('textColor'))+' '+(sw.dataset.bg||sw.dataset.ink||'')));
    node.querySelectorAll('[data-pane="style"] .fn-help').forEach(n=>n.remove());
    text('[data-photo-group] h3','photoTitle');prefix('.fn-upload','uploadPhoto');
    const help=el('[data-photo-group] .fn-help');if(help)help.textContent=L('photoGuide');
    [['[data-zoom]','crop'],['[data-pan-x]','panX'],['[data-pan-y]','panY'],['[data-filter-amount]','filterStrength']].forEach(([s,k])=>prefix(s,k));
    const photoHeadings=node.querySelectorAll('[data-photo-group] h3');if(photoHeadings[1])photoHeadings[1].textContent=L('filter');if(photoHeadings[2])photoHeadings[2].textContent=L('border');
    node.querySelectorAll('[data-filter]').forEach(n=>n.textContent=L('filter.'+n.dataset.filter));
    node.querySelectorAll('[data-border]').forEach(n=>n.textContent=L('border.'+n.dataset.border));
    node.querySelectorAll('[data-photo-group] .fn-help').forEach((n,i)=>{if(i>0)n.remove();});
    text('[data-status]','ready');text('[data-add]','add');el('[data-download]')?.remove();
  }

  function fieldsFor(template, settings){
    const defaults=settings?.defaultValues||{};
    return template.fields.map(f=>{
      const key='default.'+template.id+'.'+f.id;
      const translated=L(key);
      const configured=defaults[f.id];
      const isExample=String(configured??'')===String(f.value??'');
      let value=String(configured!=null&&!isExample?configured:(translated===key?(configured??f.value):translated));
      if(f.uppercase)value=value.toLocaleUpperCase().replace(/[^\p{L}\p{M} .'-]/gu,'');
      if(f.numeric)value=value.replace(/\D/g,'');
      return {...f,value:value.slice(0,f.max)};
    });
  }
  function getProductForm(entry){
    const scope=entry.closest('product-info')||entry.closest('.shopify-section')||document;
    return [...scope.querySelectorAll('form[action*="/cart/add"]')].find(f=>f.querySelector('[name="id"]'))||null;
  }
  function init(entry){
    if(entry.dataset.fannurInit==='1')return;
    entry.dataset.fannurInit='1';
    const form=getProductForm(entry);
    if(form){
      form.querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"]').forEach(btn=>btn.classList.add('fannur-hide-atc'));
      const pay=form.parentElement?.querySelector('.shopify-payment-button');
      if(pay)pay.classList.add('fannur-hide-atc');
    }
    entry.querySelector('.fannur-open')?.addEventListener('click',()=>open(entry,form));
    if(cartEditorId)resumeCartDesign(entry,form);
  }
  function readDimensions(entry,form){
    const variants=parseJSON(entry.dataset.waVariants||'[]',[]);
    const selectedId=String(form?.querySelector('[name="id"]')?.value||entry.dataset.waVariantId||'');
    const variant=Array.isArray(variants)?variants.find(v=>String(v.id)===selectedId):null;
    const title=variant?.public_title||variant?.title||'';
    const m=String(title).match(/(\d{2,3})(?:[.,]\d+)?\s*[x×]\s*(\d{2,3})(?:[.,]\d+)?/i);
    let w=40,h=60;
    if(m){w=Number(m[1]);h=Number(m[2]);}
    else {
      const d=parseJSON(entry.dataset.waConfig||'{}',{});
      if(Array.isArray(d.formatCm)&&d.formatCm.length===2){w=Number(d.formatCm[0]);h=Number(d.formatCm[1]);}
    }
    if(!(w>0&&h>0&&h/w>.75&&h/w<2.2)){w=40;h=60;}
    const canvasW=900,canvasH=Math.round(canvasW*h/w),outputW=canvasW*3,outputH=canvasH*3;
    return {w,h,canvasW,canvasH,outputW,outputH,selectedId};
  }
  function open(entry,form,restore=null){
    if(document.querySelector('.fannur-modal'))return;
    const settings=parseJSON(entry.dataset.waConfig||'{}',{});
    const requestedType=entry.dataset.waType||'photo-upload';
    const requestedTemplate=entry.dataset.waTemplate|| (requestedType==='text-only'?'text-quote':'photo-classic');
    const template=TEMPLATES[requestedTemplate];
    if(!template||template.type!==requestedType||!MODULES[requestedType]){
      window.alert(L('errorGeneric'));
      return;
    }
    const format=readDimensions(entry,form);
    if(!/^\d+$/.test(format.selectedId)){window.alert(L('errorVariant'));return;}
    const cartProps=restore?.item?.properties||{};
    const saved=parseJSON(cartProps['_Design instellingen']||'{}',{});
    if(restore&&saved.template&&saved.template!==template.id){
      window.alert(L('errorResume'));return;
    }
    const baseFields=fieldsFor(template,settings);
    const restoredValues=Object.fromEntries(baseFields.map(f=>[f.id,saved.values?.[f.id]??cartProps[f.label]??f.value]));
    const fields=restore?fieldsFor(template,{...settings,defaultValues:restoredValues}):baseFields;
    if(!FONT_SERVICE?.create){window.alert(L('errorGeneric'));return;}
    const extraFonts=[...parseJSON(entry.dataset.waFonts||'[]',[]),...(Array.isArray(settings.fonts)?settings.fonts:[])];
    const fontLibrary=FONT_SERVICE.create(extraFonts);
    const roles=Array.isArray(template.fontRoles)?template.fontRoles:[{id:'heading',label:'Hoofdtekst',default:'classic-serif'}];
    const fontChoices=[...new Set([...(template.fonts||[]),...extraFonts.map(f=>f.id)])]
      .filter(id=>!Array.isArray(settings.allowedFonts)||settings.allowedFonts.includes(id));
    const availableChoices=fontLibrary.list(fontChoices);
    const allowedForRole=role=>fontChoices.filter(id=>{
      const item=fontLibrary.get(id);
      if(!item)return false;
      if(Array.isArray(role.allowed)&&!role.allowed.includes(id)&&item.source!=='url')return false;
      if(Array.isArray(item.roles)&&!item.roles.includes(role.id))return false;
      if(Array.isArray(settings.allowedFontsByRole?.[role.id])&&!settings.allowedFontsByRole[role.id].includes(id))return false;
      return true;
    });
    const fontValues=Object.fromEntries(roles.map(r=>{
      const ids=allowedForRole(r);
      const desired=saved.fonts?.[r.id]||settings.defaultFonts?.[r.id]||r.default;
      return [r.id,ids.includes(desired)&&fontLibrary.get(desired)?desired:ids.find(id=>fontLibrary.get(id))||'classic-serif'];
    }));
    const fontFamilies=Object.fromEntries(roles.map(r=>[r.id,fontLibrary.get(fontValues[r.id])?.family||'Georgia']));
    const state={
      values:Object.fromEntries(fields.map(f=>[f.id,f.value])),
      bg:hex(saved.bg,hex(settings.background,template.background)),
      ink:hex(saved.ink,hex(settings.ink,template.ink)),
      fonts:fontValues,fontFamilies:fontFamilies,font:template.font,
      image:null,imageUrl:null,imageFile:null,
      zoom:Number.isFinite(+saved.zoom)?+saved.zoom:110,panX:Number.isFinite(+saved.panX)?+saved.panX:0,panY:Number.isFinite(+saved.panY)?+saved.panY:0,
      filter:saved.filter||'original',filterAmount:Number.isFinite(+saved.filterAmount)?+saved.filterAmount:65,border:saved.border||'none',
      location:saved.location||null,meta:{},backgroundImg:null,
      jerseyLayout:template.layout==='jersey'&&settings.jerseyLayout&&typeof settings.jerseyLayout==='object'?settings.jerseyLayout:{},
      fontWeights:template.layout==='jersey'?{name:settings.fontWeights?.name||'bold',number:settings.fontWeights?.number||'bold'}:{}
    };
    const overlay=document.createElement('section');
    overlay.className='fannur-modal';overlay.setAttribute('role','dialog');overlay.setAttribute('aria-modal','true');
    overlay.setAttribute('aria-label','Personaliseer je wanddecoratie');
    const fieldHtml=fields.map(field=>{
      const pattern=field.numeric?'inputmode="numeric" pattern="[0-9]*"':field.uppercase?'autocapitalize="characters" spellcheck="false"':'';
      return `<label class="fn-field"><span>${esc(field.label)} <small class="fn-counter" data-counter="${esc(field.id)}">${esc(field.value.length)}/${esc(field.max)}</small></span>
        <input data-field="${esc(field.id)}" value="${esc(field.value)}" maxlength="${field.max}" ${pattern} autocomplete="off" /></label>`;
    }).join('');
    const swatches=(colors,name,selected)=>colors.map(c=>`<button type="button" class="fn-swatch ${c.toLowerCase()===selected.toLowerCase()?'active':''}" data-${name}="${c}" style="--swatch:${c}" aria-label="${name==='bg'?'Achtergrond':'Tekstkleur'} ${c}" title="${c}"></button>`).join('');
    const fontSelectors=roles.map(role=>{
      const allowed=allowedForRole(role);
      const choices=availableChoices.filter(font=>allowed.includes(font.id));
      return `<label class="fn-field">${esc(role.label)}<select data-font-role="${esc(role.id)}">${choices.map(font=>`<option value="${esc(font.id)}" ${fontValues[role.id]===font.id?'selected':''}>${esc(font.label)}</option>`).join('')}</select></label>`;
    }).join('');
    const photoHtml=template.type==='photo-upload'?`
      <section class="fn-control-group" data-photo-group><h3>Jouw foto</h3><label class="fn-upload">+ Upload een foto<input type="file" data-photo accept="image/jpeg,image/png,image/webp" /></label>
      <p class="fn-help">${esc(L('photoGuide'))}</p>
      <div class="fn-warning" data-photo-warning hidden></div>
      <label class="fn-field">Uitsnede / zoom <output data-zoom-value>110%</output><input type="range" data-zoom min="100" max="240" value="110" /></label>
      <label class="fn-field">Foto horizontaal verschuiven<input type="range" data-pan-x min="-100" max="100" value="0" /></label>
      <label class="fn-field">Foto verticaal verschuiven<input type="range" data-pan-y min="-100" max="100" value="0" /></label>
      <h3>Fotofilter</h3><div class="fn-chips" data-filters>${[['original','Origineel'],['mono','Zwart-wit'],['warm','Warm'],['soft','Soft'],['noir','Contrast']].map(([k,v])=>`<button type="button" data-filter="${k}" ${k==='original'?'class="active"':''}>${v}</button>`).join('')}</div>
      <label class="fn-field">Filtersterkte<input type="range" data-filter-amount min="0" max="100" value="65" /></label>
      <h3>Gedrukte rand</h3><div class="fn-chips" data-borders>${[['none','Geen'],['thin','Dun'],['wide','Breed']].map(([k,v])=>`<button type="button" data-border="${k}" ${k==='none'?'class="active"':''}>${v}</button>`).join('')}</div>
      </section>`:'';
    overlay.innerHTML=`
      <header class="fn-head"><strong>FANNUR <span>${esc(L('brand'))}</span></strong><div class="fn-head-title">${esc(entry.dataset.waProductTitle||template.name)}</div><button type="button" class="fn-close" data-close aria-label="Sluiten">×</button></header>
      <div class="fn-layout">
        <div class="fn-preview"><div class="fn-poster"><canvas data-preview width="${format.canvasW}" height="${format.canvasH}" aria-label="Voorvertoning van jouw poster"></canvas></div><span class="fn-dimensions">${format.w} × ${format.h} cm · ${esc(template.name)}</span></div>
        <aside class="fn-panel"><div class="fn-panel-content"><p class="fn-eyebrow">MAAK HET PERSOONLIJK</p><h2>${esc(template.name)}</h2>
          <nav class="fn-tabs" aria-label="Customizer onderdelen"><button type="button" class="active" data-tab="text">TEKST</button>${template.lockedStyle?'':'<button type="button" data-tab="style">KLEUR & STIJL</button>'}${template.type==='photo-upload'?'<button type="button" data-tab="photo">FOTO</button>':''}</nav>
          <div class="fn-tab-body" data-pane="text"><h3>Persoonlijke gegevens</h3>${fieldHtml}
          ${fields.some(f=>f.id==='coordinates')&&settings.geoapifyKey?`<div class="fn-location"><label class="fn-field">Adres / locatie zoeken <input type="search" data-location-search placeholder="Bijv. Utrecht, Nederland" autocomplete="off" /></label><div data-location-results class="fn-results" role="listbox"></div><p class="fn-help" data-geo-status>${esc(L('locationHint'))}</p></div>`:''}
          </div>
          <div class="fn-tab-body" data-pane="style" hidden><h3>Achtergrondkleur</h3><div class="fn-swatches" data-bg-picker>${swatches((Array.isArray(settings.colors)&&settings.colors.length?settings.colors:template.colors).filter(c=>/^#[0-9a-f]{6}$/i.test(c)), 'bg',state.bg)}</div>
          <h3>Tekstkleur</h3><div class="fn-swatches" data-ink-picker>${swatches(template.inks,'ink',state.ink)}</div>
          <h3>${esc(L('fonts'))}</h3>${fontSelectors}
          </div>
          <div class="fn-tab-body" data-pane="photo" hidden>${photoHtml}</div>
        </div>
        <div class="fn-actions"><p class="fn-status" role="status" aria-live="polite" data-status>Bekijk je ontwerp voordat je bestelt.</p><div class="fn-action-buttons"><button type="button" class="fn-primary" data-add>IN WINKELWAGEN</button></div></div>
      </aside></div>`;
    localizeDialog(overlay,template,fields,roles,settings);
    document.body.appendChild(overlay); document.body.classList.add('fannur-modal-open');
    const q=s=>overlay.querySelector(s),qa=s=>[...overlay.querySelectorAll(s)];
    const preview=q('[data-preview]'),ctx=preview.getContext('2d');
    const drawModule=MODULES[template.type];
    const previousFocus=document.activeElement;
    let destroyed=false;
    const renderer=(c,W,H)=>{
      c.save();c.scale(W/format.canvasW,H/format.canvasH);
      drawModule.draw(c,template,state,format.canvasW,format.canvasH);
      // Exact dezelfde layoutlogica voor scherm en print.
      c.restore();
    };
    function redraw(){if(destroyed)return;renderer(ctx,format.canvasW,format.canvasH);}
    function setStatus(msg,isError=false){const el=q('[data-status]');el.textContent=customerErrorText(msg);el.classList.toggle('fn-status-error',isError);}
    function close(){
      destroyed=true;
      if(state.imageUrl)URL.revokeObjectURL(state.imageUrl);
      overlay.remove();document.body.classList.remove('fannur-modal-open');document.removeEventListener('keydown',keyHandler);
      previousFocus?.focus?.();
    }
    function keyHandler(e){
      if(e.key==='Escape'){close();return;}
      if(e.key!=='Tab')return;
      const all=qa('button:not([disabled]), input:not([disabled]), select:not([disabled])').filter(n=>n.getClientRects().length);
      if(!all.length)return;
      if(e.shiftKey&&document.activeElement===all[0]){e.preventDefault();all.at(-1).focus();}
      else if(!e.shiftKey&&document.activeElement===all.at(-1)){e.preventDefault();all[0].focus();}
    }
    document.addEventListener('keydown',keyHandler);
    q('[data-close]').addEventListener('click',close);
    q('[data-close]').focus();
    qa('[data-tab]').forEach(btn=>btn.addEventListener('click',()=>{
      qa('[data-tab]').forEach(b=>b.classList.toggle('active',b===btn));
      qa('[data-pane]').forEach(p=>p.hidden=p.dataset.pane!==btn.dataset.tab);
    }));
    if(restore?.mode==='edit')q('[data-add]').textContent=L('save');
    if(restore?.mode==='copy')setStatus(L('copied'));
    qa('[data-field]').forEach(inp=>inp.addEventListener('input',()=>{
      const f=fields.find(f=>f.id===inp.dataset.field);
      let v=inp.value;
      if(f.uppercase)v=v.toLocaleUpperCase().replace(/[^\p{L}\p{M} .'-]/gu,'');
      if(f.numeric)v=v.replace(/\D/g,'');
      v=v.slice(0,f.max);
      inp.value=v;
      state.values[f.id]=v;
      q(`[data-counter="${CSS.escape(f.id)}"]`).textContent=`${v.length}/${f.max}`;
      redraw();
    }));
    qa('[data-bg]').forEach(b=>b.addEventListener('click',()=>{
      state.bg=b.dataset.bg;qa('[data-bg]').forEach(x=>x.classList.toggle('active',x===b));redraw();
    }));
    qa('[data-ink]').forEach(b=>b.addEventListener('click',()=>{
      state.ink=b.dataset.ink;qa('[data-ink]').forEach(x=>x.classList.toggle('active',x===b));redraw();
    }));
    let fontLoading=0;
    function setFontBusy(loading){
      fontLoading+=loading?1:-1;
      const blocked=fontLoading>0;
      q('[data-add]').disabled=blocked;
    }
    qa('[data-font-role]').forEach(sel=>sel.addEventListener('change',async()=>{
      const role=sel.dataset.fontRole,nextId=sel.value,previous=state.fonts[role];
      sel.disabled=true;setFontBusy(true);setStatus('Even wachten… lettertype wordt geladen.');
      try{
        const loaded=await fontLibrary.load(nextId);
        if(destroyed)return;
        state.fonts[role]=nextId;state.fontFamilies[role]=loaded.family;
        redraw();setStatus('Lettertype toegepast op je ontwerp.');
      }catch(err){sel.value=previous;setStatus(errorText(err),true);}
      finally{sel.disabled=false;setFontBusy(false);}
    }));
    if(template.type==='photo-upload'){
      q('[data-photo]').addEventListener('change',async e=>{
        const file=e.target.files?.[0];if(!file)return;
        if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>15*1024*1024){setStatus('Kies een JPG, PNG of WebP van maximaal 15 MB.',true);return;}
        let url=null;
        try{
          url=URL.createObjectURL(file);
          const img=new Image();
          await new Promise((resolve,reject)=>{img.onload=resolve;img.onerror=()=>reject(Error('Deze foto kan niet worden geopend.'));img.src=url;});
          if(!img.naturalWidth||!img.naturalHeight)throw Error('Foto heeft geen geldige afmetingen.');
          if(state.imageUrl)URL.revokeObjectURL(state.imageUrl);
          state.imageUrl=url;state.image=img;state.imageFile=file;
          const warn=q('[data-photo-warning]');
          const tooSmall=img.naturalWidth<1400||img.naturalHeight<1400;
          warn.hidden=!tooSmall;
          warn.textContent=tooSmall?L('smallPhoto'):'';
          setStatus('Foto toegevoegd. Je kunt de uitsnede en filters aanpassen.');redraw();
        }catch(err){if(url)URL.revokeObjectURL(url);setStatus(errorText(err),true);}
      });
      const sliders=[['[data-zoom]','zoom'],['[data-pan-x]','panX'],['[data-pan-y]','panY'],['[data-filter-amount]','filterAmount']];
      sliders.forEach(([selector,key])=>q(selector).addEventListener('input',e=>{
        state[key]=Number(e.target.value);
        if(key==='zoom')q('[data-zoom-value]').textContent=state.zoom+'%';
        redraw();
      }));
      [['[data-filter]','filter','[data-filters]'],['[data-border]','border','[data-borders]']].forEach(([selector,key,parent])=>{
        qa(selector).forEach(b=>b.addEventListener('click',()=>{
          state[key]=b.dataset[key];qa(parent+' '+selector).forEach(x=>x.classList.toggle('active',x===b));redraw();
        }));
      });
    }
    // Geocode via Geoapify Address Autocomplete; sleutel moet voor je shopdomein
    // restricties krijgen. Geen publieke Nominatim autocomplete (verboden).
    if(q('[data-location-search]')&&settings.geoapifyKey){
      const search=q('[data-location-search]'),list=q('[data-location-results]');
      let timer=0,controller=null;
      search.addEventListener('input',()=>{
        clearTimeout(timer);controller?.abort();list.replaceChildren();
        const term=search.value.trim();if(term.length<3)return;
        timer=setTimeout(async()=>{
          controller=new AbortController();
          try{
            const p=new URLSearchParams({text:term,format:'json',limit:'6',lang:window.FANNUR_I18N?.language||'en',apiKey:settings.geoapifyKey});
            const resp=await fetch('https://api.geoapify.com/v1/geocode/autocomplete?'+p,{signal:controller.signal});
            if(!resp.ok)throw Error('Zoeken tijdelijk niet beschikbaar');
            const json=await resp.json();list.replaceChildren();
            for(const loc of (json.results||[])){
              if(!Number.isFinite(loc.lat)||!Number.isFinite(loc.lon))continue;
              const btn=document.createElement('button');btn.type='button';btn.className='fn-result';
              btn.textContent=loc.formatted||loc.address_line1||loc.city||L('locationSearch');
              btn.addEventListener('click',()=>{
                state.location={label:btn.textContent,latitude:loc.lat,longitude:loc.lon};
                search.value=btn.textContent;list.replaceChildren();
                const coord=formatCoordinates(loc.lat,loc.lon);
                const input=q('[data-field="coordinates"]');input.value=coord;input.dispatchEvent(new Event('input',{bubbles:true}));
                q('[data-geo-status]').textContent=`GPS: ${loc.lat.toFixed(5)}, ${loc.lon.toFixed(5)}`;
              });
              list.appendChild(btn);
            }
            if(!list.children.length)list.textContent=L('noLocation');
          }catch(e){if(e.name!=='AbortError')list.textContent=L('locationUnavailable');}
        },320);
      });
    }
    if(template.type==='photo-upload'&&restore){
      const rawSource=cartProps['_FANNUR Bronfoto'];
      if(typeof rawSource==='string'&&rawSource.includes('/uploads/')){
        (async()=>{
          try{
            const u=new URL(rawSource,location.href);
            if(u.protocol!=='https:'||!(u.hostname==='cdn.shopify.com'||u.hostname===location.hostname))throw Error('Ongeldige foto-URL.');
            const response=await fetch(u.href,{credentials:'omit'});
            if(!response.ok)throw Error('Bronfoto niet beschikbaar.');
            const blob=await response.blob();
            if(!blob.type.startsWith('image/')||blob.size>15*1024*1024)throw Error('Bronfoto voldoet niet aan de bestandslimiet.');
            const file=new File([blob],'fannur-bronfoto'+(blob.type==='image/png'?'.png':'.jpg'),{type:blob.type});
            const url=URL.createObjectURL(file),img=new Image();
            await new Promise((resolve,reject)=>{img.onload=resolve;img.onerror=reject;img.src=url;});
            if(destroyed){URL.revokeObjectURL(url);return;}
            state.imageFile=file;state.image=img;state.imageUrl=url;redraw();
            setStatus('De originele foto is teruggeladen. Je kunt hem aanpassen.');
          }catch(err){setStatus(L('photoReupload'),true);}
        })();
      }else setStatus('Upload de originele foto opnieuw om dit ontwerp aan te passen.',true);
    }
    if(entry.dataset.waTemplateUrl){
      const img=new Image();img.crossOrigin='anonymous';
      img.onload=()=>{if(!destroyed){state.backgroundImg=img;redraw();}};
      img.onerror=()=>setStatus('De ontwerpachtergrond kan niet worden geladen.',true);
      img.src=entry.dataset.waTemplateUrl;
    }
    async function renderPng(){
      if(template.requiresBackground&&(!state.backgroundImg||!state.backgroundImg.naturalWidth))throw Error('Het POD-artwork ontbreekt of is nog niet geladen. Controleer het metafield POD IMAGE.');
      if(template.layout==='jersey'&&(!String(state.values.name||'').trim()||!/^[0-9]{1,2}$/.test(String(state.values.number||'')))){
        throw Error('Vul een naam en een rugnummer van één of twee cijfers in.');
      }
      // CRITISCH: fontbestanden moeten daadwerkelijk geladen zijn voordat Canvas
      // tekst naar pixels omzet; anders verschijnt er onopgemerkt een fallback.
      for(const role of roles){
        const loaded=await fontLibrary.load(state.fonts[role.id]);
        state.fontFamilies[role.id]=loaded.family;
      }
      if(document.fonts?.ready)await document.fonts.ready;
      const out=document.createElement('canvas');out.width=format.outputW;out.height=format.outputH;
      const outputCtx=out.getContext('2d',{alpha:false});
      if(!outputCtx)throw Error('Kan de PNG-renderer niet starten.');
      renderer(outputCtx,format.outputW,format.outputH);
      const blob=await new Promise((resolve,reject)=>out.toBlob(b=>b?resolve(b):reject(Error('PNG kon niet worden gemaakt.')),'image/png'));
      const bytes=new Uint8Array(await blob.slice(0,24).arrayBuffer());
      const sig=[137,80,78,71,13,10,26,10];
      if(blob.type!=='image/png'||bytes.length!==24||!sig.every((n,i)=>bytes[i]===n))throw Error('Het ontwerpbestand is geen geldige PNG.');
      const view=new DataView(bytes.buffer);
      if(view.getUint32(16)!==format.outputW||view.getUint32(20)!==format.outputH)throw Error('De PNG-afmetingen komen niet overeen met de gekozen variant.');
      if(blob.size>18*1024*1024)throw Error('De PNG is groter dan 18 MB. Verklein je originele foto of kies een eenvoudiger filter.');
      return blob;
    }
    function getVariantId(){return String(form?.querySelector('[name="id"]')?.value||format.selectedId);}
    function submitToCart(blob){
      if(typeof File!=='function'||typeof DataTransfer!=='function')throw Error('Je browser ondersteunt de bestandsbijlage niet.');
      const designId='FN-'+Date.now().toString(36).toUpperCase()+'-'+Math.random().toString(36).slice(2,8).toUpperCase();
      const png=new File([blob],designId+'.png',{type:'image/png',lastModified:Date.now()});
      const fileInput=document.createElement('input');fileInput.type='file';fileInput.name='properties[Ontwerp PNG]';fileInput.accept='image/png';
      const dt=new DataTransfer();dt.items.add(png);fileInput.files=dt.files;
      if(fileInput.files.length!==1||fileInput.files[0].size!==blob.size)throw Error('De PNG-bijlage kon niet aan het formulier worden toegevoegd.');
      const cartForm=document.createElement('form');cartForm.action=sourceRoot+'cart/add';cartForm.method='POST';cartForm.enctype='multipart/form-data';cartForm.acceptCharset='UTF-8';cartForm.hidden=true;
      const field=(name,value)=>{const el=document.createElement('input');el.type='hidden';el.name=name;el.value=String(value);cartForm.appendChild(el);};
      const id=getVariantId();if(!/^\d+$/.test(id))throw Error('Selecteer eerst een geldige productvariant.');
      const qty=Number(restore?.item?.quantity||form?.querySelector('[name="quantity"]')?.value||1);
      field('form_type','product');field('utf8','✓');field('id',id);
      field('quantity',Number.isInteger(qty)&&qty>=1?qty:1);
      field('properties[Ontwerpnummer]',designId);
      field('properties[_FANNUR PNG resolutie]',`${format.outputW} × ${format.outputH} px`);
      field('properties[_FANNUR Template]',template.id);
      for(const f of fields)field(`properties[${f.label}]`,state.values[f.id]||'');
      if(state.location){field('properties[GPS]',`${state.location.latitude.toFixed(6)}, ${state.location.longitude.toFixed(6)}`);field('properties[Locatie]',state.location.label);}
      field('properties[_Customizer]','FANNUR v0.5');
      // Shopify heeft limieten voor line item properties; alleen compacte instellingen.
      const designData=JSON.stringify({v:5,template:template.id,values:state.values,bg:state.bg,ink:state.ink,fonts:state.fonts,filter:state.filter,filterAmount:state.filterAmount,border:state.border,zoom:state.zoom,panX:state.panX,panY:state.panY,location:state.location});
      field('properties[_Design instellingen]',designData);
      const plan=form?.querySelector('[name="selling_plan"]')?.value;if(plan)field('selling_plan',plan);
      if(template.type==='photo-upload'&&state.imageFile){
        const srcInput=document.createElement('input');srcInput.type='file';srcInput.name='properties[_FANNUR Bronfoto]';
        const srcDT=new DataTransfer();srcDT.items.add(state.imageFile);srcInput.files=srcDT.files;cartForm.appendChild(srcInput);
      }
      cartForm.appendChild(fileInput);document.body.appendChild(cartForm);
      if(restore?.mode==='edit'){
        sessionStorage.setItem('fannur_pending_edit',JSON.stringify({oldDesignId:restore.id,newDesignId:designId,created:Date.now()}));
      }
      HTMLFormElement.prototype.submit.call(cartForm);
    }
    const toggleBusy=flag=>{q('[data-add]').disabled=flag;};
    q('[data-add]').addEventListener('click',async()=>{
      toggleBusy(true);q('[data-add]').textContent=L('saving');
      setStatus('Momentje… je artwork wordt voorbereid.');
      try{
        if(entry.dataset.waDemo==='true')throw Error('Demo: bestellen is uitgeschakeld. Test de PNG-download.');
        if(template.type==='photo-upload'&&!state.image)throw Error('Upload eerst je eigen foto.');
        const png=await renderPng();setStatus('Je artwork wordt aan de bestelling toegevoegd.');submitToCart(png);
      }catch(err){setStatus(errorText(err),true);toggleBusy(false);q('[data-add]').textContent=restore?.mode==='edit'?L('save'):L('add');}
    });
    redraw();
    // Standaardfont van het product (bijv. Google of Shopify-font) vooraf laden.
    (async()=>{
      setFontBusy(true);
      try{
        setStatus('Lettertypen worden voorbereid…');
        for(const role of roles){
          const font=await fontLibrary.load(state.fonts[role.id]);
          state.fontFamilies[role.id]=font.family;
        }
        if(!destroyed){redraw();setStatus('Je kunt nu je ontwerp aanpassen en bestellen.');}
      }catch(e){if(!destroyed)setStatus(errorText(e),true);}
      finally{if(!destroyed)setFontBusy(false);}
    })();
  }
  function formatCoordinates(lat,lon){
    return `${Math.abs(lat).toFixed(4)}°${lat>=0?'N':'S'} ${Math.abs(lon).toFixed(4)}°${lon>=0?'E':'W'}`;
  }
  const start=()=>document.querySelectorAll('.fannur-entry').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  // Shopify section-reload / quick view. Vermijd herhaald re-initialiseren.
  let timer;new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(start,180);}).observe(document.documentElement,{subtree:true,childList:true});
})();
